var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongYiwen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5a6.48 6.48 0 004.596-1.904A6.48 6.48 0 0014.5 8a6.48 6.48 0 00-1.904-4.596A6.48 6.48 0 008 1.5a6.48 6.48 0 00-4.596 1.904A6.48 6.48 0 001.5 8a6.48 6.48 0 001.904 4.596A6.48 6.48 0 008 14.5z",
    stroke: "#3F465C",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.407V9.08c0-.441.378-.783.77-.985a1.688 1.688 0 10-2.458-1.502",
    stroke: "#3F465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11.998a.7.7 0 100-1.399.7.7 0 000 1.399z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_yiwen.41e7239f.svg";
export { SvgTongyongYiwen as ReactComponent };